import { useCallback, useEffect, useRef, useState } from 'react';
import { TRANSITION_TIME_NUMBER } from '../constants';
export function useOutsideAlerter() {
  const ref = useRef(null);
  const [isInteractingWithVerticalNav, setIsInteractingWithVerticalNav] = useState(false);
  const [shouldPauseInteractionAlerting, setShouldPauseInteractionAlerting] = useState(false);
  const timeoutRef = useRef(undefined);
  const updateIsInteractingWithVerticalNav = useCallback(nextState => evt => {
    if (shouldPauseInteractionAlerting) return;
    if (!nextState && evt && evt.type === 'blur' && ref.current && evt.relatedTarget && ref.current.contains(evt.relatedTarget)) {
      // needed to prevent unnecessary rerenders from shifting focus between vertical nav items
      setIsInteractingWithVerticalNav(true);
      return;
    }
    setIsInteractingWithVerticalNav(nextState);
  }, [shouldPauseInteractionAlerting]);
  const tempPauseOutsideAlerter = () => {
    if (timeoutRef.current) return;
    setShouldPauseInteractionAlerting(true);
    setIsInteractingWithVerticalNav(false);
    timeoutRef.current = setTimeout(() => {
      setShouldPauseInteractionAlerting(false);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }, TRANSITION_TIME_NUMBER);
  };
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  useEffect(() => {
    function handleOnBlur() {
      // document.activeElement is set in the next event loop in Firefox
      setTimeout(() => {
        const {
          activeElement
        } = document;
        if (activeElement && activeElement.tagName === 'IFRAME') {
          setIsInteractingWithVerticalNav(false);
        }
      }, 0);
    }
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsInteractingWithVerticalNav(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('blur', handleOnBlur, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('blur', handleOnBlur, true);
    };
  }, [ref]);
  return {
    verticalNavContainerRef: ref,
    isInteractingWithVerticalNav,
    updateIsInteractingWithVerticalNav,
    tempPauseOutsideAlerter
  };
}